import React, {FC} from "react"
import styled, {css} from "styled-components"

import Spacing, {SpacingProps} from "@irati/ui/src/Spacing"
import Flex from "@irati/ui/src/Flex"

interface DotProps {
  isSelected?: boolean
}

export const Dot = styled(Flex)<DotProps>`
  ${({theme, isSelected}) => css`
    width: 10px;
    height: 10px;
    display: inline-block;
    background: ${isSelected ? theme.colors.primary2 : theme.colors.primary2_50};
    border-radius: 50%;
    margin-right: ${theme.spacing.one};
  `}
`

interface Props extends SpacingProps {
  stepCount: number
  currentStep: number
}

const StepIndicatorDots: FC<Props> = (props) => {
  const {stepCount, currentStep, ...rest} = props
  const iterableArr = [...Array(stepCount)]
  return (
    <Spacing {...rest}>
      {iterableArr.map((_item, i) => {
        return <Dot key={i} isSelected={i === currentStep} />
      })}
    </Spacing>
  )
}

export default StepIndicatorDots
